import { useStableKeys } from 'hooks';
import { Stack } from 'libs/ui';
import { useFormContext } from 'modules/client/common/forms/orderSubmissionContactsForm';

import { Fields, Header } from './components';

export interface FormContentProps {
  onRemoveOrderSubmissionContact: (index: number) => void;
}

export const FormContent = ({
  onRemoveOrderSubmissionContact,
}: FormContentProps) => {
  const { values, readOnly } = useFormContext();

  const orderSubmissionContactsKeys = useStableKeys(
    values.orderSubmissionContacts
  );

  return (
    <Stack spacing={24}>
      {values.orderSubmissionContacts.map((_, index) => (
        <Stack key={orderSubmissionContactsKeys[index]} spacing={12}>
          <Header
            index={index}
            readOnly={readOnly}
            onRemoveOrderSubmissionContact={onRemoveOrderSubmissionContact}
          />
          <Fields index={index} />
        </Stack>
      ))}
    </Stack>
  );
};
